import { getRouteApi } from '@tanstack/react-router'
import { CircularProgress } from 'ui/components'

import { LicenseDetailsPage } from './components/LicenseDetailsPage'
import { useLicenseDetails } from './hooks'

const routeApi = getRouteApi('/_app/licenses/$licenseId')

const LicenseDetails = () => {
  const { licenseId } = routeApi.useParams()
  const id = parseInt(licenseId || '0')

  const {
    isFetching,
    data,
    invoicesTableConfig,
    documentsTableConfig,
    historyTableConfig,
    onInvoiceDeleted,
    onDocumentDeleted
  } = useLicenseDetails(id)

  return (
    <>
      {isFetching && !data && <CircularProgress centered />}
      {!!data && (
        <LicenseDetailsPage
          data={data}
          invoicesTableConfig={invoicesTableConfig}
          documentsTableConfig={documentsTableConfig}
          historyTableConfig={historyTableConfig}
          onInvoiceDeleted={onInvoiceDeleted}
          onDocumentDeleted={onDocumentDeleted}
        />
      )}
    </>
  )
}

export default LicenseDetails
